import { DimensionedNumberDisplay } from "common/components/DimensionedNumberDisplay";
import { NewJobsFormState } from "../FormState";
import { StackedDetail } from "../StackedDetail";
import { useFormikContext } from "formik";
import { useSelf } from "portal/state/store";
import { useTranslation } from "react-i18next";
import React from "react";

export const LaserWeedingConfirmDetailsSection: React.FC = () => {
  const { values } = useFormikContext<NewJobsFormState>();
  const { t } = useTranslation();
  const { measurementSystem } = useSelf();

  return (
    <>
      <div className="grid grid-flow-row grid-cols-4 grid-rows-[min-content]">
        <StackedDetail labelI18nKey="models.autotractor.jobType">
          {t("models.autotractor.jobTypes.laserWeed")}
        </StackedDetail>
      </div>
      <hr className="w-full" />
      <div className="grid grid-flow-row grid-cols-4 grid-rows-[min-content]">
        <StackedDetail labelI18nKey="models.pathPlanning.laserWeed.rowSpacing">
          <DimensionedNumberDisplay
            storedValue={values.laserWeed.rowSpacingM}
            storedUnit="m"
            displayUnits={{ imperial: "ft", metric: "m" }}
            localSystem={measurementSystem}
          />
        </StackedDetail>
      </div>
    </>
  );
};
